// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__1xQ35","container":"styles_container__IC9Zl"};